export default "__VITE_ASSET__CHgnPplg__"